export default __webpack_public_path__ + "static/media/logo-consul@3x.b8125c3a.svg";